import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminPartnerService } from '../services/admin-partner.service';

export function useAdminPayoutBatches(params?: {
  page?: number;
  limit?: number;
  status?: string;
}) {
  return useQuery({
    queryKey: ['admin', 'payouts', 'batches', params],
    queryFn: () => adminPartnerService.getPayoutBatches(params),
  });
}

export function useGeneratePayoutBatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params?: { partnerIds?: string[]; minAmount?: number }) =>
      adminPartnerService.generatePayoutBatch(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'payouts'] });
    },
  });
}

export function useProcessPayoutBatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (batchId: string) => adminPartnerService.processPayoutBatch(batchId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'payouts'] });
    },
  });
}
